import AbstractChart from './AbstractChart';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import moment from 'moment';
import { chartColorCode } from './colorCodes';
import {
  CHART_BACKGROUND_COLOUR,
  DEFAULT_CHART_HEIGHT,
  FILTER_DATE_RANGE_FORMAT,
  DEFAULT_TITLE_STYLE,
  DEFAULT_NO_DATA_OPTIONS,
  SERIES_KEY,
  TITLE_KEY,
  TEXT_KEY
} from './constants/HighchartsConstants';
import { renderChart } from './CommonChartMethods';

HighchartsMore(Highcharts);

class SourcesPercentColumnChart extends AbstractChart {
  constructor(props) {
    super(props);
    this.state = {
      mapDataFromProps: {},
      chartData: [],
      source: [],
      topicId: [],
      filterDateRange: {
        fromDate: moment().format(FILTER_DATE_RANGE_FORMAT),
        toDate: moment().format(FILTER_DATE_RANGE_FORMAT),
      },
      mapOptions: {
        chart: {
          type: 'column',
          backgroundColor: CHART_BACKGROUND_COLOUR,
          marginBottom: 30,
          marginLeft: 60,
          marginRight:20,
          width: 740,
          height: DEFAULT_CHART_HEIGHT,
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          enabled: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          y: 0,
          x: 0,
          itemStyle: {
            color: '#999999',
            fontWeight: 'normal',
            fontSize: '10px',
            textTransform: 'capitalize',
          },
        },
        noData: {...DEFAULT_NO_DATA_OPTIONS},
        title: {...DEFAULT_TITLE_STYLE},
        tooltip: { 
          enabled: true,
          valueSuffix: "%",
          valueDecimals: 2
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          labels: {
            rotation: 0,
            style: {
              color: '#999999',
              fontSize: '8px',
              lineHeight: '5px',
              textTransform: 'capitalize',
            },
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: '8px',
            },
            y: 2,
          },

          tickInterval: 10,
          title: {
            text: 'Percent of Headlines',
            style: {
              fontSize: '8px'
            }
          },
        },
      },
    };
  }

  reRenderChartOnChange = props => {
    const { retrieveSelectedChartData } = this.props.actions;
    this.setState(
      {
        filterDateRange: props.dateRangeFilterValue,
        source: props.source,
        topicId: props.selectedTopicId,
      },
      () => {
        retrieveSelectedChartData({
          chartId: this.props.chartId.replace('chart', ''),
          dateFilterValue: this.state.filterDateRange,
          topicId: this.state.topicId,
          source: this.state.source,
        });
      },
    );
  };

  componentDidMount() {
    this.reRenderChartOnChange(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { chartId, selectedTopicId, source } = this.props;
    if (
      JSON.stringify(newProps.SourcesPercentColumnChartt[chartId]) !==
        JSON.stringify(this.state.mapDataFromProps) &&
      newProps.selectedTopicId != null
    ) {
      this.setState({ chartData: [] });
      const { title } = this.props;
      let { mapOptions } = this.state;
      const chartData = newProps.SourcesPercentColumnChartt[chartId];
      if (chartData && chartData.hasOwnProperty("data")) {
        let series_data  = chartData["data"];
        for (let i=0; i< series_data.length; i++) {
          const series_name = series_data[i]["name"];
          series_data[i]["color"] = chartColorCode[series_name.toLowerCase()];
          series_data[i]["dataLabels"] = {
            enabled: true,
            align: 'center',
            format: '{point.y:.0f}%',
            y: 4,
            style: {
              color:  series_data[i]["color"],
              fontSize: '5px',
              fontWeight: 'bold',
              textOutline: 0,
            },
          };
        }
        mapOptions[SERIES_KEY] = series_data;
      }
      mapOptions['xAxis']['categories'] = chartData["sources"];
      mapOptions[TITLE_KEY][TEXT_KEY] = this.props.title;
      this.setState({
        chartData,
        mapOptions,
        mapDataFromProps: this.props.SourcesPercentColumnChartt[chartId],
        source,
      });
    }

    if (this._shouldReRenderChartBasedOnNewProps(newProps)) {
      this.reRenderChartOnChange(newProps);
    }
  }

  render() {
    const { mapOptions, mapDataFromProps } = this.state;
    return renderChart(mapOptions, mapDataFromProps);
  }
}

function mapStateToProps(state) {
  return {
    SourcesPercentColumnChartt: state.charts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SourcesPercentColumnChart);



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/SourcesPercentColumnChart.js